module.exports = __webpack_public_path__ + "img/voucher.a36632b9.svg";